<template>
  <app-menu></app-menu>
</template>

<script setup>
import AppMenu from './AppMenu.vue';
</script>

<style lang="scss" scoped></style>
